var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurfBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9997 2.58006C22.0109 2.22729 21.721 1.96893 21.3523 2.00302C19.7374 2.15296 18.1758 2.49957 16.6844 3.01435L17.3495 6.59503L21.2577 7.00117C21.6936 5.57653 21.9507 4.09729 21.9997 2.58006Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44739 11.6666C7.90375 8.17529 11.2774 5.28723 15.2185 3.5835L16.0278 7.94057L20.7534 8.43166C19.2115 12.2891 16.3605 15.6797 12.83 18.2451L7.41119 16.7131L5.44739 11.6666Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41611 13.2579C3.40026 14.9649 2.59552 16.7845 2.03746 18.6576C1.88757 19.1607 2.20157 19.6768 2.72791 19.8256L4.00045 20.1854L4.46009 21.3665C4.65163 21.8587 5.21617 22.1226 5.73435 21.944C7.64749 21.2846 9.49735 20.4007 11.2212 19.328L6.22901 17.9166L4.41611 13.2579Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurfBoard);
export default __webpack_public_path__ + "static/media/surf-board.512795c878c4c46ffff525f110f9414d.svg";
export { ForwardRef as ReactComponent };